module.exports = __webpack_public_path__ + "static/microsoftMcaps-d70f1030ee4c36c6e4931bc2016f141f.jpg";